<app-admin-boilerplate>
    @if (eventList$ | async; as events){
        @for (event of events; track $index){
            <app-admin-event-summary [event]="event" />
        }
    }
</app-admin-boilerplate>